import { getRogueLevel } from './cunningAction';

export const STEADY_AIM_ADVANTAGE_ID = 'rogue:steady-aim:advantage';
export const STEADY_AIM_SPEED_ID = 'rogue:steady-aim:speed';
export const hasSteadyAim = (character) => getRogueLevel(character) >= 3;
export const currentTurnState = (combat, combatantId, definitionId) => {
  const ledger = combat?.turnActionLedger;
  return ledger?.combatantId === String(combatantId) && ledger?.turnSequence === combat?.turnSequence &&
    ledger.turnStates?.some((state) => state.definitionId === definitionId && state.combatantId === String(combatantId));
};
export const hasMovedThisTurn = (combat, combatantId) => currentTurnState(combat, combatantId, 'movement:moved');
export const getSteadyAimAdvantage = (combat, combatantId) => (combat?.activeEffects || []).find((effect) =>
  effect.definitionId === STEADY_AIM_ADVANTAGE_ID && effect.sourceCombatantId === String(combatantId) &&
  effect.appliedAtTurnSequence === combat?.turnSequence) || null;
